import { render } from "./FinancialAdviserSelectionView.vue?vue&type=template&id=71c32c96"
import script from "./FinancialAdviserSelectionView.vue?vue&type=script&lang=js"
export * from "./FinancialAdviserSelectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__